import { Link } from "react-router-dom";
import { guCategories } from "@/mocks/categories";
import SubscribeForm from "@/components/feature/SubscribeForm";

const CONTACT_EMAIL = "guatian@example.com";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <section id="subscribe" className="border-b border-background-200">
        <div className="mx-auto flex w-full flex-col gap-6 px-4 py-12 md:px-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="lg:max-w-sm">
            <h2 className="font-heading text-2xl font-black text-foreground-950">
              订阅每日吃瓜速报
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              每天挑一场最值得看的瓜，附上评论区风向和三条高赞神评，三分钟看完不迷路。
            </p>
          </div>
          <div className="w-full lg:max-w-2xl">
            <SubscribeForm />
          </div>
        </div>
      </section>

      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-12 md:px-8 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-xl" />
            </span>
            <span className="font-heading text-xl font-black text-foreground-950">瓜田观察</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            一个把评论区当成正文来看的吃瓜聚合站。我们只整理公开信息，不站队，也不替任何人下结论。
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <span className="flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900">
              <i className="ri-user-voice-line text-sm" />
              评论区优先
            </span>
            <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900">
              <i className="ri-scales-3-line text-sm" />
              不站队
            </span>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-bold text-foreground-950">
            <Link to="/topics" className="cursor-pointer transition-colors hover:text-primary-700">
              热门专题
            </Link>
          </h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {guCategories.slice(1, 6).map((cat) => (
              <li key={cat.key}>
                <Link
                  to={`/topics?category=${cat.key}`}
                  className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {cat.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-foreground-950">关于本站</h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            <li>
              <Link
                to="/about"
                className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700"
              >
                品牌定位
              </Link>
            </li>
            <li>
              <Link
                to="/about#principles"
                className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700"
              >
                内容原则
              </Link>
            </li>
            <li>
              <Link
                to="/about#reviews"
                className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700"
              >
                用户口碑
              </Link>
            </li>
            <li>
              <Link
                to="/#faq"
                className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700"
              >
                常见问题
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-foreground-950">联系我们</h4>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-600">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-base text-primary-600" />
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                rel="nofollow"
                className="cursor-pointer transition-colors hover:text-primary-700"
              >
                {CONTACT_EMAIL}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-feedback-line text-base text-primary-600" />
              纠错与爆料：同上邮箱
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-base text-primary-600" />
              速报更新时间：每日 08:00
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex w-full flex-col gap-2 px-4 py-5 text-xs text-foreground-500 md:flex-row md:items-center md:justify-between md:px-8">
          <p>© 2026 瓜田观察 · 内容均为公开信息整理，不代表平台立场</p>
          <p>理性吃瓜，友善发言，评论区也需要体面。</p>
        </div>
      </div>
    </footer>
  );
}